<template>
  <app-modal :modal-id="modalId" :title="modalTitle" :preloader="preloader"
                @submit="submit" @close-modal="closeModal" 
                modal-size="large" modal-alignment="center">
        <template slot="header">
            <h5 class="modal-title" id="ModalLabel">{{ modalTitle }}</h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                :data-url='selectedUrl ? `departments/${inputs.id}` : `departments`'>
                <div class="row">
                    <div class="col-md-12">
                        <!-- Name Input -->
                        <div class="form-group">
                            <label for="name">{{ $t('name') }}</label>
                            <app-input id="name" type="text" v-model="inputs.name"
                                :placeholder="$t('name')"/>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <!-- Description Input -->
                        <div class="form-group">
                            <label for="description">{{ $t('description') }}</label>
                            <app-input id="description" type="text" v-model="inputs.description"
                                :placeholder="$t('description')" :required="true" />
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit">{{ $t('save') }}</button>
        </template>
    </app-modal>
</template>

<script>
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import { ModalMixin } from '../../../Mixins/ModalMixin';

export default {
    name: 'DepartmentAddEditModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: {
            type: String,
        },
    },
    computed: {

    },
    data() {
        return {
            preloader: false,
            modalId: 'department-add-edit-modal',
            inputs: {
                name: '',
                description: '',
            },
            isModalActive: false,
            modalTitle: `${this.$t('new')} ${this.$t('department')}`,
        }
    },
    methods: {
        submit() {
            this.save(this.inputs);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccessFromGetEditData(response) {
            this.inputs = response.data;
            this.preloader = false;
        },
    },
    created() {
        if (this.selectedUrl) {
            this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
}
</script>

<style>

</style>